import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _00_45auth_45global from "/app/middleware/00.auth.global.ts";
import _01_45admin_45routes_45global from "/app/middleware/01.admin-routes.global.ts";
import _02_45user_45routes_45global from "/app/middleware/02.user-routes.global.ts";
import _03_45booking_45manager_45routes_45global from "/app/middleware/03.booking-manager-routes.global.ts";
import booking_45redirect_45global from "/app/middleware/booking-redirect.global.ts";
import popup_45close_45global from "/app/middleware/popup-close.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _00_45auth_45global,
  _01_45admin_45routes_45global,
  _02_45user_45routes_45global,
  _03_45booking_45manager_45routes_45global,
  booking_45redirect_45global,
  popup_45close_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-only": () => import("/app/middleware/admin-only.ts"),
  "booking-manager-only": () => import("/app/middleware/booking-manager-only.ts"),
  "booking-manager": () => import("/app/middleware/booking-manager.ts"),
  "guest-only": () => import("/app/middleware/guest-only.ts"),
  "staff-only": () => import("/app/middleware/staff-only.ts")
}